import { createReducer } from "@reduxjs/toolkit";
import { PortfolioTracking } from "../../models/Portfolio";
import { loadPortfolioTracking } from "../actions/portfolioTracking";

export interface PortfolioTrackingReducer {
    portfolio: PortfolioTracking | undefined;
}

const initialState: PortfolioTrackingReducer = {
    portfolio: undefined
}


const portfolioTracking = createReducer<PortfolioTrackingReducer>(initialState, (builder) => {
    builder.addCase(loadPortfolioTracking.pending, (state) => {
        state.portfolio = undefined;
    });
    
    builder.addCase(loadPortfolioTracking.fulfilled, (state, action) => {
        state.portfolio = action.payload;
    });
});

export default portfolioTracking;